import { ArrowRight } from "lucide-react";
import humanIcon from "../../assets/icons/human.svg";
import doctorIcon from "../../assets/icons/doctor.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { STATISTICS } from "../../api/endPoint";
import { convertToYYYYMMDD } from "../../common/helpers/converDate";
import useFetch from "../../hooks/useFetch";
import { useEffect, useState } from "react";

interface IStatistics {
  today: {
    total: number;
    completed: number;
  };
  week: {
    completed: number;
    daysCompleted: number;
  };
  completedWeek: number;
}

const Therapy = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [filter] = useState({ date: convertToYYYYMMDD(new Date()) });

  const { data, fetchData } = useFetch<IStatistics>(
    STATISTICS,
    "GET",
    filter,
    null,
    { autoFetch: false }
  );

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="flex justify-center h-full">
      <div className="w-full max-w-5xl space-y-5 mt-6">
        {/* Card 1: Personal plan */}
        <div className="relative bg-primary-50 rounded-[28px] p-4 sm:p-10 overflow-visible">
          <div className="w-[60%] flex flex-col gap-3 z-1 relative">
            <p className="font-bold text-lg text-transparent bg-clip-text bg-gradient-to-br from-primary-900 to-primary-600 whitespace-normal leading-snug">
              {t("title.treatmentPlan")}
            </p>
            <p className="text-sm text-gray-700">
              {data?.today.total
                ? `${Math.round((data.today.completed / data.today.total) * 100)}% ${t("title.completed")}`
                : ""}
            </p>
            <div
              className="flex items-center gap-1 text-primary-700 cursor-pointer text-md font-bold hover:text-primary-500 transition-all duration-200"
              onClick={() => navigate("/exercise-list")}
            >
              <span> {t("title.seeMore")}</span>
              <ArrowRight size={16} />
            </div>
          </div>
          <img
            src={humanIcon}
            alt="Yoga"
            className="absolute right-[-15px] bottom-0 top-[-60px] object-contain z-2 w-[264px] h-[254px]"
          />
        </div>

        {/* Card 2 */}
        {/* <div
          className="bg-white shadow px-6 py-2 lg:py-7 flex items-center gap-4 rounded-xl"
          style={{ boxShadow: "6px 8px 24px 4px #F6944D1F" }}
        >
          <div className="flex items-center justify-center w-14 h-14 rounded-lg bg-primary-100">
            <span className="text-primary-600 text-2xl font-bold">{data?.week.completed}</span>
          </div>
          <div className="text-gray-500 font-bold">
            {" "}
            {t("title.exercisesCompleted")}
          </div>
        </div> */}

        {/* Card 3 */}
        <div
          className="bg-white shadow px-6 py-2 lg:py-7 flex items-center gap-4 rounded-xl"
          style={{ boxShadow: "6px 8px 24px 4px #F6944D1F" }}
        >
          <div className="flex items-center justify-center w-14 h-14 rounded-lg bg-green-100">
            <span className="text-green-600 text-2xl font-bold">
              {data?.week.daysCompleted}
            </span>
          </div>
          <div className="text-gray-500 ">
            <div className="text-gray-500">
              {(data?.week.daysCompleted ?? 0) === 2
                ? t("title.oneMoreDayToDo")
                : // : (data?.week.daysCompleted ?? 0) === 1
                  //   ? t("title.oneMoreDayToDo")
                  (data?.week.daysCompleted ?? 0) > 3
                  ? t("title.perfect")
                  : ""}
            </div>
            <div className="text-gray-500 font-bold">
              {t("title.completedDays")}
            </div>
          </div>
        </div>

        {/* Card 4 */}
        <div
          className="bg-white shadow px-6 py-2 sm:py-7 flex items-center gap-4 rounded-xl"
          style={{ boxShadow: "6px 8px 24px 4px #F6944D1F" }}
        >
          <div className="flex items-center justify-center w-14 h-14 rounded-lg bg-blue-100">
            <span className="text-blue-600 text-2xl font-bold">
              {data?.completedWeek}
            </span>
          </div>
          <div className="text-gray-500 font-bold">
            {" "}
            {t("title.completedWeek")}
          </div>
        </div>

        {/* Card 5: Ask your therapist */}
        <div
          className="relative bg-white shadow px-6 py-7 sm:py-10 overflow-visible rounded-xl "
          style={{ boxShadow: "6px 8px 24px 4px #F6944D1F" }}
        >
          <div className="flex items-center justify-between gap-5 md:gap-16">
            <img
              src={doctorIcon}
              alt="Doctor"
              className="absolute -left--1 -top-10 w-[180px] h-[180px] object-contain z-10"
              style={{ pointerEvents: "none" }}
            />
            <div className="w-[180px]"></div>
            <div className="pl-2 flex-1 flex flex-col items-start">
              <p className="text-gray-600 font-bold">
                {t("title.askYourTherapist")}
              </p>
              <p className="text-primary-600 text-sm font-bold flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-all duration-200">
                {t("title.goToContact")}
                <ArrowRight size={16} />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Therapy;
